import styled from "styled-components";
import { darken } from "@material-ui/core";

export const ChallengeTypesWrapper = styled.div(({ theme }) => `
  margin-top: 1rem;

  input[type="radio"] {
    flex: 0 0 auto;
    height: 22px;
    margin: 0;
    width: 22px;
  }

  p {
    color: ${theme.darkGreyColor};
    font-size: 0.9rem;
    margin: 0 0 1rem;
  }
`);

export const SectionLabel = styled.div`
  font-size: 0.9rem;
  margin-bottom: 1.25rem;
`;

export const TypeGroupLabel = styled.div`
  font-size: 0.8rem;
  letter-spacing: 0;
  margin: 1rem 0 0.75rem;
  text-transform: uppercase;
`;

export const ChallengeTypeOption = styled.label(({ $selected, theme }) => `
  align-items: center;
  background: ${theme.lightColor};
  border: 1px solid ${$selected ? theme.accent2Color : "transparent"};
  border-radius: ${theme.rounded.sm};
  cursor: pointer;
  display: flex;
  gap: 16px;
  ${$selected ? `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-color: transparent;
    margin-bottom: 0;
  ` : `
    margin-bottom: 0.75rem;
  `}
  padding: 12px 18px;
  width: 100%;

  &:hover {
    background: ${darken(theme.lightColor, .015)};
  }
`);

export const ChallengeTypeIcon = styled.span(({ theme, $selected }) => `
  align-items: center;
  background: ${$selected ? theme.primaryColor : darken(theme.lightColor, 0.05)};
  border-radius: ${theme.rounded.sm};
  color: ${$selected ? theme.white : theme.primaryColor};
  display: inline-flex;
  flex: 0 0 42px;
  font-size: 1.25rem;
  height: 42px;
  justify-content: center;
  width: 42px;

  svg {
    [fill="${theme.primaryColor}" i] {
      fill: currentColor;
    }
    [stroke="${theme.primaryColor}" i] {
      stroke: currentColor;
    }
  }
`);

export const ChallengeTypeMeta = styled.span(({ theme }) => `
  display: flex;
  flex-direction: column;
  min-width: 0;

  strong {
    color: ${theme.darkColor};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.2;
  }

  span {
    color: ${theme.darkGreyColor};
    font-size: 0.85rem;
    line-height: 1.35;
  }
`);

export const ChallengeTypeBody = styled.div(({ theme, $isPopular }) => `
  background: ${theme.lightColor};
  border-radius: ${theme.rounded.sm};
  padding: ${$isPopular ? "0 24px 22px" : "18px 24px 22px"};
  ${$isPopular ? `
    border: 1px solid ${theme.accent2Color};
    border-top-color: transparent;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin: 0 0 1rem;
  ` : `
    margin: -0.25rem 0 1rem;
  `}
`);

export const ChallengeTypeHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 14px;
`;

export const ChallengeTypeExample = styled.img(({ theme }) => `
  border-radius: ${theme.rounded.sm};
  display: block;
  margin-bottom: 1rem;
  max-height: 320px;
  object-fit: cover;
  width: auto;
`);

export const MoreTypesRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 1rem;
  overflow-x: auto;
  padding-bottom: 4px;
`;

export const MoreTypePill = styled.button(({ $selected, theme }) => `
  align-items: center;
  background: ${$selected ? theme.primaryColor : theme.white};
  border: 1px solid ${theme.primaryColor};
  border-radius: 999px;
  color: ${$selected ? theme.white : theme.primaryColor};
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 400;
  gap: 8px;
  min-height: 36px;
  padding: 0 16px;
  white-space: nowrap;

  &:hover {
    background: ${$selected ? theme.primaryColor : theme.lightColor};
  }

  svg {
    [fill="${theme.primaryColor}" i] {
      fill: currentColor;
    }
    [stroke="${theme.primaryColor}" i] {
      stroke: currentColor;
    }
  }
`);
